"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function ContentBlock(_a) {
    var block = _a.block;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-subscriptions-content-block', block.image ? 'storybook-subscriptions-content-block-with-image' : 'storybook-subscriptions-content-block-center') },
        block.image && react_1.default.createElement("div", { className: 'storybook-subscriptions-content-block-image' },
            react_1.default.createElement("img", { className: block.imageClassname || '', src: "" + process.env.NEXT_PUBLIC_STORYBOOK_CDN_URL + block.image, alt: block.imageClassname })),
        react_1.default.createElement("div", { className: 'storybook-subscriptions-content-block-text', dangerouslySetInnerHTML: { __html: block.content } }));
}
exports.default = ContentBlock;
